import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import RegistrationComponents from "@/components/registration/RegistrationComponents.vue";
import ChangeComponent from "@/components/changePassword/ChangeComponent.vue";
import LoginComponents from "@/components/login/LoginComponents.vue";
import { useStore } from "vuex";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthorizationView',
  setup(__props) {

const store = useStore();
const component = ref(store.state.ComponentsTypeOperation);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(LoginComponents, null, null, 512), [
      [_vShow, component.value.component === 'login_component']
    ]),
    _withDirectives(_createVNode(RegistrationComponents, null, null, 512), [
      [_vShow, component.value.component === 'create_account']
    ]),
    _withDirectives(_createVNode(ChangeComponent, null, null, 512), [
      [_vShow, component.value.component === 'change_password']
    ])
  ], 64))
}
}

})